import { useFlags } from "launchdarkly-react-client-sdk";

import { VideoSettingsLegacy } from "./video-settings-legacy";
import { VideoSettingsV2 } from "./video-settings-v2";

/**
 * Router only: v2 settings when `contentHubSingleVideoSettingsV2` or
 * direct video sharing is on (grid uses direct sharing for metadata).
 */
export function VideoSettings() {
  const flags = useFlags();
  const singleVideoSettingsV2 = Boolean(
    flags?.contentHubSingleVideoSettingsV2 ||
      flags?.contentHubDirectVideoSharing
  );

  return singleVideoSettingsV2 ? <VideoSettingsV2 /> : <VideoSettingsLegacy />;
}
